/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
import "twin.macro";
import LandingPage from "./components/LandingPage/";
import AuthForms from "./auth/AuthForms";
import { useState, useEffect } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import HomeContainer from "./containers/HomeContainer";
import { Auth, Hub } from "aws-amplify";
import View from "./containers/view/index";

const App = () => {
  useEffect(() => {
    checkUser();
    Hub.listen("auth", (data) => {
      const { payload } = data;
      if (payload.event === "signOut") {
        setUser(null);
      }
    });
  }, []);
  const [user, setUser] = useState(null);
  async function checkUser() {
    try {

      // new demolab@singularity.ai  lod democlinical@singularity.ai
      const data = await Auth.currentUserPoolUser();
      const userInfo = { username: data.username, ...data.attributes };
      setUser(userInfo);
    } catch (err) {
      console.log("error: ", err);
    }
  }

  return (
    <HashRouter>
      <Switch>
        {/* <Route exact path="/home/view/:dzi/:slideid/:animalsid?" component={View}></Route> */}
        <Route
          path="/home"
          component={
            user ? HomeContainer : () => <AuthForms setUser={setUser} />
          }
        />
        <Route exact path="/auth" component={AuthForms} setUser={setUser} />
        <Route component={LandingPage} />
      </Switch>
    </HashRouter>
  );
};

export default App;
